var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMunicipality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2615"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    x: 3.39999,
    y: 2.95,
    width: 10.2,
    height: 15.6,
    fill: "#D9E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 19V16C7 15.6022 7.15804 15.2206 7.43934 14.9393C7.72064 14.658 8.10218 14.5 8.5 14.5C8.89782 14.5 9.27936 14.658 9.56066 14.9393C9.84196 15.2206 10 15.6022 10 16V19",
    stroke: "#024776",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 5.5V18.5V5.5Z",
    fill: "#D9E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 5.5V18.5",
    stroke: "#024776",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.25 18.5V5.5",
    stroke: "#024776",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.585 1.829L1.75 5.5H15.25L13.415 1.829C13.2904 1.57982 13.0988 1.37028 12.8618 1.22385C12.6247 1.07743 12.3516 0.999917 12.073 1H4.927C4.64839 0.999917 4.37526 1.07743 4.13823 1.22385C3.9012 1.37028 3.70963 1.57982 3.585 1.829Z",
    fill: "#D9E4EC",
    stroke: "#024776",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M0.75 19H23.25",
    stroke: "#024776",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21.25 14.5C21.25 14.8978 21.092 15.2794 20.8107 15.5607C20.5294 15.842 20.1478 16 19.75 16C19.3522 16 18.9706 15.842 18.6893 15.5607C18.408 15.2794 18.25 14.8978 18.25 14.5C18.4201 12.6721 18.9287 10.8918 19.75 9.25C20.5713 10.8918 21.0799 12.6721 21.25 14.5Z",
    fill: "#D9E4EC",
    stroke: "#024776",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M19.75 16V19",
    stroke: "#024776",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMunicipality);
export default __webpack_public_path__ + "static/media/municipality.27c47f53e04ad655c40451560cd9eece.svg";
export { ForwardRef as ReactComponent };